import React from 'react';
import {defineMessages, FormattedMessage} from 'react-intl';

const messages = defineMessages({
    title: {
        id: 'join.title',
        defaultMessage: 'Регистрация'
    },
    linkSentTo: {
        id: 'join.link_sent_to',
        defaultMessage: 'Ссылка для подтверждения была выслана на {email}'
    }
});

export default class extends React.Component {
    static propTypes = {
        languageId: React.PropTypes.number.isRequired,
        email: React.PropTypes.string.isRequired,
        cancelCallback: React.PropTypes.func.isRequired
    };

    render() {
        const email = this.props.email;

        return (
            <div className="modal--dialog">
                <div className="modal--header">
                    <div className="header-inner--logotype__link"></div>
                    <div className="header-inner__title">
                        <FormattedMessage {...messages.title}/>
                    </div>
                    <button className="modal__close modal__close__green modal__close__js"
                            onClick={this.props.cancelCallback}/>
                </div>
                <div className="modal--content">
                    <div className="modal--content__wrapper">
                        <p className="plain-text__paragraph modal--auth-recover__title">
                        <span className="modal--auth-recover__title__span">
                            <FormattedMessage {...messages.linkSentTo} values={{email}}/>
                        </span>
                        </p>
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./js/sport-betting/components/registration/fast/EmailRegistrationSuccess.jsx